// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hover-text .mtdicon{margin:0 2px;cursor:pointer}", "",{"version":3,"sources":["webpack://./app/src/components/HoverText/index.scss"],"names":[],"mappings":"AACE,qBACE,YAAA,CACA,cAAA","sourcesContent":[".hover-text {\n  .mtdicon {\n    margin: 0 2px;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
